export default __webpack_public_path__ + "static/media/1.bcd76ad0.svg";